var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.176,
    height: 38.111,
    viewBox: "0 0 38.176 38.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 38.176,
    height: 38.111,
    fill: "#2e90d8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(-15 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(15 7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34317",
    "data-name": "Path 34317",
    d: "M20.206,38.111H17.97a1.994,1.994,0,0,0-.288-.061A17.635,17.635,0,0,1,10.991,36.3,18.816,18.816,0,0,1,.3,22.374c-.142-.725-.2-1.466-.3-2.2V17.942a2.534,2.534,0,0,0,.063-.321,17.611,17.611,0,0,1,2.183-7.505A18.747,18.747,0,0,1,18.288.035a17.724,17.724,0,0,1,9.754,2.207,18.773,18.773,0,0,1,9.834,13.5c.14.726.2,1.466.3,2.2v2.233a2.533,2.533,0,0,0-.063.321A17.9,17.9,0,0,1,35.934,28a18.832,18.832,0,0,1-13.521,9.811c-.728.14-1.471.2-2.207.3M19.1,1.733a17.325,17.325,0,1,0,17.342,17.34A17.364,17.364,0,0,0,19.1,1.733",
    transform: "translate(0 0)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34318",
    "data-name": "Path 34318",
    d: "M236.63,230.123H233.2v-9.491h3.411v1.22a6.361,6.361,0,0,1,1.239-.907,3.3,3.3,0,0,1,3.848.608,3.973,3.973,0,0,1,.941,2.458c.068,1.994.053,3.991.071,5.987a.467.467,0,0,1-.037.119h-3.44v-.391c0-1.525,0-3.051,0-4.576a5.812,5.812,0,0,0-.067-.925,1.06,1.06,0,0,0-.859-1,1.213,1.213,0,0,0-1.33.608,3.416,3.416,0,0,0-.33,1.309c-.039,1.512-.015,3.025-.015,4.538v.44",
    transform: "translate(-215.812 -204.152)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.418,
    height: 9.489,
    transform: "translate(12.179 16.482)",
    fill: "#2e90d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34319",
    "data-name": "Path 34319",
    d: "M166.437,164.46a1.727,1.727,0,1,1-1.742-1.709,1.718,1.718,0,0,1,1.742,1.709",
    transform: "translate(-150.83 -150.616)",
    fill: "#2e90d8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.6aa0ce6681de3c344aa5e7b86a568fc1.svg";
export { ForwardRef as ReactComponent };